module.exports = __webpack_public_path__ + "assets/img/IMG037.2c56621f.png";